module.exports = __webpack_public_path__ + "img/stock3.27b9744a.png";